import { en_messages } from '@/lang/en/messages';
import { ru_messages } from '@/lang/ru/messages';
import { uz_messages } from '@/lang/uz/messages';
import { tr_messages } from "@/lang/tr/messages";
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: localStorage.getItem("currentLang"),
    //fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: {
        en: {
            message: en_messages
        },
        tr: {
            message: tr_messages
        },
        ru: {
            message: ru_messages
        },
        uz: {
            message: uz_messages
        }
    }
});